import { Component, model, ModelSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TicketEditService } from 'src/app/_provider/ticket-edit.service';
import { Employee } from 'src/app/_interfaces/employee';
import { AFSSelectMultipleInputComponent, AFSSelectOption } from '@afs-ng/inputs';
@Component({
    selector: 'assign-employees',
    templateUrl: './assign-employees.component.html',
    styleUrls: ['./assign-employees.component.scss'],
    standalone: true,
    imports: [FormsModule, AFSSelectMultipleInputComponent]
})
export class AssignEmployeesComponent {
  public selectedEmployeeIds: ModelSignal<number[]> = model<number[]>([])
  public employees: Employee[] = []

  public selectedOptions: AFSSelectOption[] = []

  public get selectOptions(): AFSSelectOption[]{
    return this.employees.map(e => ({name: `${e?.firstName} ${e?.lastName}`, value: e.id}))
  }

  constructor(
    private ticketEditSrv: TicketEditService
  ){}

  ngOnInit(){
    this.employees = JSON.parse(JSON.stringify(this.ticketEditSrv.employees))
  }

  public clear(){
    this.selectedEmployeeIds.set([])
    this.selectedOptions = []
  }

  public selectionChanged(){
    this.selectedEmployeeIds.set(this.employees
      .filter(e => this.selectedOptions
      .some(o => o.value === e.id))
      .map(e => e.id)
    )
  }
}
